<template>
  <i class="fas fa-thumbs-up thumb-icon"></i>
</template>

<script>
export default {
  name: 'ThumbUp',
};
</script>

<style lang="scss">
@import './ChatWidget.scss';
</style>
